import moment from 'moment'
import { funcModal } from 'components/modals'
import { hasPermits } from 'directives'
import datepicker from 'components/datepicker'
import pagination from 'components/pagination'

const directives = {
  hasPermits
}

const components = {
  funcModal,
  datepicker,
  pagination,
}

const computed = {
  need_to_save () {
    return this.$store.state.channels.active.need_to_save;
  },

  errors () {
    if (this.$store.state.channels.errors) {
      return this.$store.state.channels.errors.errors;
    }

    return {}
  },

  error () {
    return this.$store.state.channels.errors;
  }
}

const methods = {

  showWebhookLogs () {
    this.showLogs = true;
  },

  loadPage (page) {
    this.$route.query.page = page;
    let data = {page, id: this.$route.params.id, status: this.filters.status};

    this.loading = true;

    if (this.filters.from_date ) {
      data.from_date = moment(this.filters.from_date, ['MM/DD/YYYY']).format('YYYY-MM-DD');
    } 
    if (this.filters.to_date) {
      data.to_date = moment(this.filters.to_date, ['MM/DD/YYYY']).format('YYYY-MM-DD');
    }

    return (this.$store.dispatch('channels.getWebhooks', data)).then (() => {
      this.webhooks = _.cloneDeep(this.$store.state.channels.webhooks);
      this.loading = false;
    });
  },

  generatekey () {
    const result = Math.random().toString(36).substring(2,12);
    this.form.webhook_secret_key = result;
  }

}

const watch = {
  formData (n, o) {
    if (n == o) return;

    this.form = n;
  },
  activeTab (n) {
    console.log(n.title);
    if (this.showLogs && n.title == "Webhook") {
      this.loadPage(1);
    }
  }
}

export default {
  name: 'general-tab',
  props: ['formData', 'activeTab'],
  components,
  computed,
  methods,
  directives,
  watch,
  data () {
    return {
      // errors: {},
      saving: false,
      form: this.formData,
      page: 1,
      filters: {
        from_date: null,
        to_date: null,
        status: 'all'
      },
      webhooks: [],
      showLogs: false,
      loading: false
    }
  }

  , created() {
    this.loadPage (this.$route.query.page || 1);
    // this.webhooks = this.formData.webhooks;
  }
}
